/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.AjaxFilter = (function () {

    function AjaxFilter() {

        Monet.UI.Fields.TextField.apply (this, arguments);

        this.createBaseStructure();

        this.rootEl.className = 'MonetUIAjaxFilter';

        this.appendIconFilter = function () {

            var error = null,
                divIconFilter = null;

            try {

                divIconFilter = document.createElement('div');
                divIconFilter.className = 'MonetUIAjaxIconFilter';

                this.rootEl.appendChild(divIconFilter);

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    'Error on append Icon filter');
                error.console();

            }

        };

        this.callbackForSearch = function () {

            console.log('Your class need implements this method.');

        };

        this.addListeners = function () {

            var inputText = this.rootEl.querySelector('input[type=text]'),
                context = this;

            if (inputText) {

                $(inputText).typeWatch({
                    callback: function () {

                        context.callbackForSearch();

                    },
                    wait: 750,
                    captureLength: 0
                })
                    .off('keypress')
                    .on('keypress', function (e) {
                        if (e.keyCode === 13) {
                            e.preventDefault();
                        }
                    });

            }
        };

        this.render = function () {

            var error = null;

            try {

                this.createElement();
                this.appendIconFilter();
                this.addListeners();

                return this.rootEl;

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    'Error on render ajax filter');
                error.console();
            }

        };
    }

    AjaxFilter.prototype = new Monet.UI.Fields.TextField();

    return AjaxFilter;

}());